<template>
  <div class="">
    <button class="btn-indigo font-normal w-32" @click="openModal()">Campaign</button>
    <ModalHeadlessUI ref="modal">
      <template #default>
        <h1 class="font-bold mb-4 text-3xl text-center">
          Add Campaign Tasks
        </h1>
        <form id="form" name="form" @submit.prevent="addAutomations">          
          <label class="form-label">Set Date and Time:</label>
            <div class="flex items-center mr-2 mb-4">
              <input id="now" v-model="form.trigger_time" value="" type="radio" class="rounded-full h-4 w-4 border border-gray-300 bg-white checked:bg-indigo-500 checked:border-indigo-500 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"/>
              <label for="Now" class="flex items-center text-sm font-light cursor-pointer">Start Now (or select Date/Time)</label>
            </div>
          <Datepicker v-model="form.trigger_time" class="mb-4 pr-6 w-full" :is-24="false" />
          <div v-if="form.errors.trigger_time" class="form-error pb-4 w-full">{{ form.errors.trigger_time }}</div>
          <select-input v-model="form.campaign" class="pb-4 w-full" label="Campaign Templates">
            <option v-for="(campaign, index) in campaigns" :key="campaign.id" :value="campaign.id">{{ campaign.name }}</option>
          </select-input>
          <div v-if="form.errors.campaign" class="form-error">{{ form.errors.campaign }}</div>
          <div class="flex justify-center items-center mt-5">
            <div>
              <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Add Campaign</loading-button>
            </div>
          </div>
        </form>
      </template>
    </ModalHeadlessUI>
  </div>
</template>

<script>
import ModalHeadlessUI from '@/Shared/ModalHeadlessUI'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Datepicker from '@vuepic/vue-datepicker'
import { router } from '@inertiajs/vue3'

export default {
  components: {
    ModalHeadlessUI,
    SelectInput,
    LoadingButton,
    Datepicker
  },
  props: {
    campaigns:{
      type: Object,
      default: null,
    },
    contact:{
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      form: router.form({
        // contact_id: this.contact.id,
        trigger_time: '',
        campaign: '',
      }),
    }
  },
  methods:{
    openModal() {
      this.$refs.modal.openModal()
    },
    closeModal() {
      this.$refs.modal.closeModal()
    },
    addAutomations() {
      if (!this.form.campaign) {
        alert('Select a Campaign!')
        return
      }
      this.form.post('/taskAutomationContact/'+this.contact.id+'/'+this.form.campaign, {
        onSuccess: () => {
          this.form.reset('campaign')
          this.closeModal()
        },
      })

    },
  },
}
</script>
